import React, { useEffect, useState } from 'react';
import { onErrorShowMessage } from '~src/errors';
import ProjectItem from '../ProjectItem/ProjectItem';
import { FIND_USER_RECENT_CANVASES } from '../../~graphql/queries/editorProjects';
import getGraphQlClient from '~graphql/getGraphQlClient';
import { unmarshalGraphqlResponse } from '~graphql/utils';
import { Spinner } from 'react-bootstrap';
import { router } from '~src/router';

const RecentProjects = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState([]);

  const fetchEditorProjects = async (forceFetch = false) => {
    const limit = 12;

    try {
      const graphQlClient = await getGraphQlClient();

      let where = {};

      where.status = {
        equalTo: 'active',
      };

      const response = await graphQlClient.query({
        fetchPolicy: forceFetch ? 'network-only' : 'cache-first',
        variables: { limit, where },
        query: FIND_USER_RECENT_CANVASES,
      });

      return unmarshalGraphqlResponse(response.data, 'findEditorCanvas');
    } catch (error) {
      onErrorShowMessage();
      console.error(error);
    }
  };

  useEffect(() => {
    const forceFetch = reload.length > 0;
    fetchEditorProjects(forceFetch)
      .then((result) => {
        setItems(result.edges);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        onErrorShowMessage();
      });
  }, [reload]);

  const showProject = (project) => {
    return (
      <ProjectItem
        setReload={setReload}
        key={project.objectId}
        objectId={project.objectId}
        name={project.metadata.servizioName}
        metadata={project.metadata}
        pages={project.editor_canvas_pages.edges?.map((page) => page.node)}
        gifPreviewId={project.editor_canvas_pages.edges[0]?.node.gifPreviewId}
      />
    );
  };

  const toProjectsButton = () => (
    <div className="col-12 my-4 text-center">
      <a
        href={`${process.env.ROUTE_PROJECTS}`}
        onClick={(event) => {
          event.preventDefault();
          router.navigate(`${process.env.ROUTE_PROJECTS}`);
        }}
      >
        <div
          id="editor-btn-loader-goto-projects"
          type="button"
          className="btn btn-secondary p-3"
        >
          Vedi tutti i progetti
        </div>
      </a>
    </div>
  );

  return (
    <>
      {loading && (
        <Spinner
          className="my-4 mx-auto text-dark"
          animation="border"
          size="lg"
          variant="info"
        />
      )}
      {!loading && items.length == 0 && (
        <h5 className="my-5 mx-auto text-dark">Nessun progetto trovato</h5>
      )}
      {items.map(showProject)}
      {items.length > 0 && toProjectsButton()}
    </>
  );
};

export default RecentProjects;
